import { render, staticRenderFns } from "./Ordenanzas.vue?vue&type=template&id=078be42f&scoped=true&"
import script from "./Ordenanzas.vue?vue&type=script&lang=ts&"
export * from "./Ordenanzas.vue?vue&type=script&lang=ts&"
import style0 from "./Ordenanzas.vue?vue&type=style&index=0&id=078be42f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078be42f",
  null
  
)

export default component.exports